import { observer } from 'mobx-react';
import React from 'react';
import { withCheckoutStore } from '../../context';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { ORDER_STATUS } from 'src/constants/order';
import { CheckoutStore } from 'src/mobx/checkoutStore';
import { TBooleanInNumber } from 'src/types/main';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from 'src/view/components/Text/Text';

// @ts-ignore
@withCheckoutStore
@observer
export default class CheckoutResendSMS extends React.Component<{ checkoutStore?: CheckoutStore }> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }
  /**
   * Change toggle send sms
   */
  onChange = (send_sms: TBooleanInNumber) => {
    this.checkoutStore.toggleSendSMS(send_sms);
  };

  /**
   * Template btn send sms
   */
  private sendSMSToggle = () => {
    return (
      <div className="d-flex flex-row flex-1 align-items-center">
        <Switcher status={this.checkoutStore.params.send_sms_with_geo} onChange={this.onChange} />
        <Text type={TEXT.SWITCHER_LABEL} text="send_sms_toggle" />
      </div>
    );
  };

  public render() {
    if (
      this.checkoutStore.dependencies.order?.order_status_code === ORDER_STATUS.DRAFT &&
      this.checkoutStore.params.delivery_type === DELIVERY_TYPE.DELIVERY
    ) {
      return this.sendSMSToggle();
    }
    return null;
  }
}
